<template>
  <div class="container color-grey">
    <div class="content footer">
      <div class="row">
        <div>
          <h5 class="font-size-15">了解我们</h5>
          <ul>
            <li class="font-size-14">
              <router-link to="/about_us?tab=0">公司介绍</router-link>
            </li>
            <li class="font-size-14">
              <router-link to="/about_us?tab=4">商务合作</router-link>
            </li>
            <li class="font-size-14">
              <router-link to="/about_us?tab=3">加入我们</router-link>
            </li>
          </ul>
        </div>
        <div>
          <h5 class="font-size-15">放薪管家</h5>
          <ul>
            <li class="font-size-14">
              <a href="/website/maker?id=3">关于放薪管家</a>
            </li>
          </ul>
        </div>
        <div>
          <h5 class="font-size-15">金创客</h5>
          <ul>
            <li class="font-size-14">
              <a href="/website/out_source?id=4">关于金创客</a>
            </li>
          </ul>
        </div>
        <!-- <div>
          <h5 class="font-size-15">零工教育</h5>
          <ul>
             <li class="font-size-14"><a href="/website/education">关于教育</a></li>
          </ul>
        </div>-->
        <div>
          <h5 class="font-size-15">微信公众号</h5>
          <ul>
            <li class="font-size-14">
              <img
                class="qrcode"
                src="https://lgbfss-www.oss-cn-beijing.aliyuncs.com/www/official/images/qrcode_lgbfss.jpg"
                alt
                srcset
              />
              <p>
                <a href>了解相关资讯</a>
              </p>
            </li>
          </ul>
        </div>
        <div class="contact" style="text-align:left;">
          <h5 class="font-size-15">联系邮箱</h5>
          <ul>
            <li class="font-size-14">
              <a href="mailto:lgbfss@foxmail.com">lgbfss@foxmail.com</a>
            </li>
          </ul>
          <h5 class="font-size-15">客服专线</h5>
          <ul>
            <li class="font-size-14">
              <a href="tel:18729372124">18729372124</a>
            </li>
          </ul>
          <h5 class="font-size-15">
            <a href>公司地址</a>
          </h5>
          <ul>
            <li class="font-size-14">陕西省西咸新区秦汉新城秦汉文创大厦5层</li>
          </ul>
        </div>
      </div>
    </div>
    <div style="border-top:6px solid #343434"></div>
    <div class="baianhao">
      <a
        href="https://beian.miit.gov.cn/"
        target="_blank"
        rel="noopener noreferrer"
      >©陕西零工保信息科技有限公司 ALL RIGHTS RESERVED 陕ICP备19002438号</a>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
.footer {
  padding: 30px 100px;
  line-height: 20px;
  text-align: center;
}
.footer a {
  color: #e3e3e3;
}
.footer h5 {
  margin-bottom: 10px;
  font-weight: 500;
}
.footer li {
  margin-top: 20px;
  color: #e3e3e3;
}
.qrcode {
  width: 140px;
  height: 140px;
  display: block;
  margin: 0 auto;
  margin-bottom: 10px;
}
.contact h5 {
  margin-bottom: 10px !important;
}
.contact li {
  margin-top: 0 !important;
  margin-bottom: 20px;
}
.baianhao {
  text-align: center;
  line-height: 50px;
}
.baianhao > a {
  color: #ffffff;
  font-size: 12px;
}
</style>